function roundToTenth(n) {
  return Math.round(Number(n) * 10) / 10;
}

function formatMillions(n) {
  if (!Number.isFinite(n) || n === 0) return '0';
  return Number(n).toFixed(1);
}

export function incrementForBreakpoint(name, reportData) {
  if (!name || !String(name).includes('|')) return 0;
  const row = reportData?.BreakpointAnalyses?.breakpoints?.[name];
  if (!Array.isArray(row)) return 0;
  return row.reduce((sum, val) => sum + (Number(val) || 0), 0);
}

/**
 * Next header start is always the previous header's rounded end, so ranges
 * cannot gap or overlap ($213.1 followed by $213.0).
 */
export function chainedRangeLabels(sortedBreakpoints, incrementalByName, priorCumulative = 0) {
  let cum = Number(priorCumulative) || 0;
  let prevRounded = roundToTenth(cum / 1e6);
  const labels = {};
  (sortedBreakpoints || []).forEach((name) => {
    if (!name || !String(name).includes('|')) {
      labels[name] = name;
      return;
    }
    cum += Number(incrementalByName?.[name]) || 0;
    const endRounded = roundToTenth(cum / 1e6);
    labels[name] = `$${formatMillions(prevRounded)}M – $${formatMillions(endRounded)}M`;
    prevRounded = endRounded;
  });
  return labels;
}

export function labelsForBreakpoints(sortedBreakpoints, reportData, priorCumulative = 0) {
  const incrementalByName = Object.fromEntries(
    (sortedBreakpoints || []).map((name) => [name, incrementForBreakpoint(name, reportData)]),
  );
  return chainedRangeLabels(sortedBreakpoints, incrementalByName, priorCumulative);
}

export function labelsForOpmBreakpoints(
  sortedBreakpoints,
  reportData,
  opmIncrementalOptionValue,
  priorCumulative = 0,
) {
  const names = sortedBreakpoints || [];
  const incrementalByName = {};
  names.forEach((name, index) => {
    const fromAnalyses = incrementForBreakpoint(name, reportData);
    if (fromAnalyses) {
      incrementalByName[name] = fromAnalyses;
      return;
    }
    if (!name?.includes('|')) {
      incrementalByName[name] = 0;
      return;
    }
    const current = Number(opmIncrementalOptionValue?.[name]?.breakpointValue) || 0;
    const nextRange = names.slice(index + 1).find((candidate) => candidate?.includes('|'));
    const terminal = names.find((candidate) => candidate === 'All Participate');
    const nextValue = nextRange
      ? Number(opmIncrementalOptionValue?.[nextRange]?.breakpointValue) || 0
      : Number(opmIncrementalOptionValue?.[terminal]?.breakpointValue) || current;
    incrementalByName[name] = Math.max(nextValue - current, 0);
  });
  return chainedRangeLabels(names, incrementalByName, priorCumulative);
}

export function displayBreakpointHeader(breakpointName, labels, wrap = false) {
  if (!breakpointName?.includes('|')) {
    return String(breakpointName || '').replace('All Participate', '\nAll\nParticipate');
  }
  const label = labels?.[breakpointName];
  if (!label) return breakpointName;
  if (wrap) return label.replace(' – ', ' –\n');
  return label;
}
